<template>
   <el-container class="wrapper">
    <el-header><HeaderDom></HeaderDom></el-header>
    <el-container>
      <el-aside width="240px"><AsideDom></AsideDom></el-aside>
      <el-main class="content-box" :class="{'content-collapse':collapse}">
          <div class="content">
            <Breadcrumb></Breadcrumb>
            <div class="content-y">
              <div class="content-main">
                <transition name="move" mode="out-in">
                    <router-view></router-view>
                </transition>
              </div>
            </div>
          </div>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
//引入Header Component
import HeaderDom from '@/views/common/layout/HeadDom'
//引入Aside Component
import AsideDom from '@/views/common/layout/AsideDom'
//引入面包屑Breadcrumb
import Breadcrumb from '@/components/breadcrumb'

import bus from '../../common/js/bus';
export default {
  data(){
    return {
      collapse: false
    }
  },
  components: {
    HeaderDom,
    AsideDom,
    Breadcrumb
  },
  computed: { 
    routes() {
      return this.$router.options.routes;
    }
  },
  methods: {
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
    }
  },
  created(){
      bus.$on('collapse', msg => {
          this.collapse = msg;
      })
  }
};
</script>
<style scoped>
.el-header,
.el-footer {
  /*background-color: #2d1113;*/
  background-color:#0f44c1;
  color: #333;
  text-align: center;
  line-height: 50px;
}
/* .aside {
  width: 240px !important;
  height: 600px;
  background-color: rgb(70, 49, 50);
} */
.el-main {
  padding: 0;
  font-size: 14px;
}
.content-box {
    position: absolute;
    left: 240px;
    right: 0;
    top: 60px;
    bottom: 0;
    -webkit-transition: left .3s ease-in-out;
    transition: left .3s ease-in-out;
    /* background: #fff;  */
    background-color: #f6faff;
    display: flex;
    flex-direction: column;
}

.content {
    display: flex;
    flex: 1;
    flex-direction: column;
    box-sizing: border-box;
    width: auto;
    height: 100%;
    /* padding: 5px 0px 5px 0px; */
    overflow-y: hidden;
}

.content-y {
  overflow-y: auto;
}

.content-main {
  margin: 10px 20px 20px 20px;
  overflow-x: hidden;
  overflow-y: hidden;
}

.content-collapse {
    left: 65px;
}

.container {
    padding: 30px;
    background: #fff;
    border: 1px solid #ddd;
    border-radius: 5px;
}

.wrapper {
    width: 100%;
    height: 100%;
    overflow: hidden;
}
</style>


// WEBPACK FOOTER //
// src/views/common/Index.vue